<template>
  <KpisEnderecosExternosCards :kpis="kpis" :loading="loading" :turnos="turnos" />
</template>

<script>
import apiController from "@/utils/apiController";
import EventBus from "@/utils/eventBus";
import KpisEnderecosExternosCards from "./KpisEnderecosExternosCards.vue";

/**
 * KPIs de validação de endereço de uma origem (C = candidatos, P = pré-candidatos), lidos do
 * snapshot da rotina CALCULA KPIS ENDERECOS EXTERNOS. Carrega quando a aba fica ativa e
 * quando a agência muda; os números não dependem de paginação nem de filtros de coluna.
 */
export default {
  name: "KpisEnderecosOrigemPainel",
  components: { KpisEnderecosExternosCards },
  props: {
    origem: {
      type: String,
      required: true,
    },
    ativa: {
      type: Boolean,
      default: false,
    },
    /** Agência do filtro da tela; vazio = todas. */
    idAgencia: {
      type: [Number, String],
      default: null,
    },
    /** Turnos que ganham chip (id_turno, cod_turno, descricao_turno). */
    turnos: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    kpis: null,
    loading: false,
    /** Só a resposta da última requisição vale; as anteriores são descartadas. */
    reqSeq: 0,
  }),
  watch: {
    ativa: {
      immediate: true,
      handler(value) {
        if (value) this.carregar();
      },
    },
    idAgencia() {
      if (this.ativa) this.carregar();
    },
  },
  methods: {
    async carregar() {
      const seq = ++this.reqSeq;
      this.loading = true;
      try {
        const data = { origem: this.origem };
        if (this.idAgencia != null && this.idAgencia !== '') data.id_agencia_emprego = this.idAgencia;
        const response = await apiController.request(apiController.endpoints.getkpisEnderecosexternos, {
          data,
          config: { timeout: 30000 },
          silent: true,
        });
        if (seq !== this.reqSeq) return;
        this.kpis = response && response.data && response.data.geral ? response.data : null;
      } catch (e) {
        if (seq !== this.reqSeq) return;
        this.kpis = null;
        EventBus.$emit('show-error', { error: e });
      } finally {
        if (seq === this.reqSeq) this.loading = false;
      }
    },
  },
};
</script>
